<!--
  @Description: 
  @Author: wang.y 
  @Date: 2022-12-07 
-->
<template>
  <div class="viewer-container">
    <div class="return-btn" @click="retrunFrom">返回</div>
    <iframe :src="protocol + '//static-cdn.vcbeat.top/pdf/web/viewer-d8.html?file=' + $route.query.file" width="100%" height="100%"></iframe>
  </div>
</template>
<script>
export default {
  computed: {
    protocol() {
      return window.location.protocol
    },
  },
  methods: {
    retrunFrom() {
      localStorage.setItem('viewer_re', 1)
      this.$router.back()
    }
  }
}
</script>
<style lang='stylus' scoped>
.viewer-container
  width 100vw
  height 100vh
  font-size 0
  line-height 1
  .return-btn
    position fixed
    right 15px
    bottom 30px
    width 50px
    height 50px
    background rgba(255, 136, 36, 0.8)
    color #fff
    font-size 12px
    text-align center
    line-height 50px
    border-radius 25px
    z-index 11199999
  iframe
    border 0
</style>